import React from "react"
import {
    SEARCH_DATA_GA,
    SEARCH_ICON_DATA_GA,
    SEARCH_DELETE_CURRENT_SEARCH_DATA_GA,
    SEARCH_KEY_PRESS_ENTER_DATA_GA,
    SEARCH_BOX_NAME,
} from "../../../../config/constants"
import {HiddenLabel, SearchBoxContainer} from "../../component"
import urls from "../../../../config/urls"
import {handlePropagation} from "../../../../utils/handlePropagation"
import {useSearchBox} from "../../hooks"
import {ClearButton, ClubForm, InputContainer, SubmitButton, ClubContainer as Container} from "./components"

export type SearchBoxProps = {
    handleSubmit: (searchTerm: string) => void
    typing: (chars: string) => void
    autocompleteTyping: ({chars, territory, cookie}: {chars: string; territory: string; cookie?: string}) => void
    backgroundImage: string
    placeholder: string
    typedCharacters: string
    openDrawer: () => void
    labelId: string
    text: {label: string; clearButton: {alt: string}}
    autoFocus: boolean
    setAutoCompleteIsLoading: () => void
    siteUrl: string
    xxlBreakpointEnabled: boolean
    autocompleteTerritory: string
    cookie?: string
}

const {clearButton: clearButtonUrl} = urls.searchBox

export const ClubSearchBox = ({
    placeholder,
    typing,
    autocompleteTyping,
    backgroundImage,
    handleSubmit,
    openDrawer,
    typedCharacters,
    labelId,
    text: {
        label,
        clearButton: {alt},
    },
    autoFocus,
    setAutoCompleteIsLoading,
    siteUrl,
    xxlBreakpointEnabled,
    autocompleteTerritory,
    cookie,
}: SearchBoxProps) => {
    const {
        handleFocus,
        handleClear,
        handleChange: handleOnChange,
        handleSubmit: handleFormSubmit,
        setTextInputRef,
    } = useSearchBox({
        autoFocus,
        searchTerm: typedCharacters,
        onAutocompleteLoading: setAutoCompleteIsLoading,
        onAutocompleteTyping: autocompleteTyping,
        onSubmit: handleSubmit,
        onTyping: typing,
        onDrawerOpening: openDrawer,
        siteUrl,
        autocompleteTerritory,
        cookie,
    })
    return (
        <SearchBoxContainer>
            <Container onClick={handlePropagation}>
                <ClubForm
                    action={`${siteUrl}/search`}
                    onSubmit={handleFormSubmit}
                    id="header-search-form"
                    xxlBreakpointEnabled={xxlBreakpointEnabled}
                >
                    <HiddenLabel htmlFor={labelId}>{placeholder}</HiddenLabel>
                    <InputContainer
                        type="text"
                        required
                        autoComplete="off"
                        inputRef={setTextInputRef}
                        inputProps={{
                            label,
                            autoFocus,
                            "data-testid": `header-search-bar-text-input`,
                            "data-ga-v1": SEARCH_DATA_GA,
                            "data-ga-enter-event": SEARCH_KEY_PRESS_ENTER_DATA_GA,
                        }}
                        onChange={handleOnChange}
                        placeholder={placeholder}
                        onFocus={handleFocus}
                        value={typedCharacters}
                        name={SEARCH_BOX_NAME}
                        id={labelId}
                        autoFocus={autoFocus}
                    />

                    {typedCharacters && (
                        <ClearButton
                            href="#"
                            data-testid="header-search-bar-clear-text-button"
                            onClick={handleClear}
                            data-ga-v1={SEARCH_DATA_GA}
                            data-ga-v3={SEARCH_DELETE_CURRENT_SEARCH_DATA_GA}
                            tabIndex={0}
                        >
                            <img src={clearButtonUrl.path} alt={alt} />
                        </ClearButton>
                    )}
                    <SubmitButton
                        type="submit"
                        value=""
                        data-testid="header-search-bar-button"
                        data-ga-v1={SEARCH_DATA_GA}
                        data-ga-v3={SEARCH_ICON_DATA_GA}
                        tabIndex={0}
                    >
                        <img src={backgroundImage} alt="Search Icon" />
                    </SubmitButton>
                </ClubForm>
            </Container>
        </SearchBoxContainer>
    )
}

export default ClubSearchBox
